var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-rating',{staticClass:"mb-2",attrs:{"readonly":"","variant":"warning","size":"sm","inline":""},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }